import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewEncapsulation,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS,
} from "@angular/material/core";
import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from "@angular/material-moment-adapter";
import { MatDatepicker } from "@angular/material/datepicker";

import * as _moment from "moment";
import { default as _rollupMoment, Moment } from "moment";

export const MONTHPICKER_FORM = {
  month: "month",
};

export const FORMATS = {
  parse: {
    dateInput: "MM/YYYY",
  },
  display: {
    dateInput: "MM/YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

const moment = _rollupMoment || _moment;

@Component({
  selector: "app-monthpicker",
  templateUrl: "./month-picker.component.html",
  styleUrls: ["./month-picker.component.scss"],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: FORMATS },
  ],
  encapsulation: ViewEncapsulation.None,
})
export class MonthPickerComponent implements OnInit {
  startDate: Date;
  endDate: Date;

  monthPickerFormGroup: FormGroup;
  maxDate: Date;

  @Output()
  getMonthValue?: EventEmitter<any> = new EventEmitter<any>();

  constructor(private fb: FormBuilder) {
    this.maxDate = _moment(new Date()).toDate();
  }

  ngOnInit(): void {
    this.createForm();
  }

  createForm() {
    this.monthPickerFormGroup = this.fb.group({
      [MONTHPICKER_FORM.month]: [null, Validators.required],
    });
    this.onDatePickerChanges(this.monthPickerFormGroup);
  }

  onDatePickerChanges(form: FormGroup): void {
    form.get(MONTHPICKER_FORM.month).valueChanges.subscribe((month) => {
      if (!month) {
        this.getMonthValue.emit(null);
      } else {
        this.getMonthValue.emit(
          this.monthPickerFormGroup.controls[MONTHPICKER_FORM.month].value
        );
      }
    });
  }

  //Must find workaround to remove this function and still have datepicker ask for year
  chosenYearHandler(normalizedYear: Moment) {}

  chosenMonthHandler(
    normalizedMonth: Moment,
    datepicker: MatDatepicker<Moment>
  ) {
    this.monthPickerFormGroup.controls[MONTHPICKER_FORM.month].setValue(
      normalizedMonth
    );
    this.getMonthValue.emit(
      this.monthPickerFormGroup.controls[MONTHPICKER_FORM.month].value
    );
    datepicker.close();
  }
}
